import { safeStorage } from './safeStorage';

const PENDING_AUTH_CHALLENGE_KEY = 'gweffit_pending_auth_challenge';

export function getPendingAuthChallenge() {
  try {
    const raw = safeStorage.get(PENDING_AUTH_CHALLENGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function setPendingAuthChallenge(nextValue) {
  try {
    if (!nextValue) {
      safeStorage.remove(PENDING_AUTH_CHALLENGE_KEY);
      return false;
    }
    safeStorage.set(PENDING_AUTH_CHALLENGE_KEY, JSON.stringify(nextValue));
    return true;
  } catch {
    return false;
  }
}

export function clearPendingAuthChallenge() {
  try {
    safeStorage.remove(PENDING_AUTH_CHALLENGE_KEY);
    return true;
  } catch {
    return false;
  }
}
